<template>

  <div class="container-lg  mt-5">
    <div class="row">
      <div v-if="shop_code !== 'tt_fi_tel_shop'" class="col-lg-3">
        <category-list :in18="in18" :root_categories="root_categories"/>
      </div><!-- /.col -->
      <div :class="shop_code === 'tt_fi_tel_shop' ? 'col-lg-12' : 'col-lg-9'">
        <gallery :gallery_banners="gallery_banners"/>
        <benefits :benefit_banners="benefit_banners"/>
        <extras :extra_banners="extra_banners"/><!-- /.container -->
      </div><!-- /.col -->
    </div><!-- /.row -->

    <home-video :video_url="home_video_url"/><!-- /.home-video -->
  </div><!-- /.container -->

  <auto-slider :in18="in18" :slider="featured_slider"/><!-- /.section -->

  <auto-slider :in18="in18" :slider="popular_slider"/><!-- /.section -->

  <auto-slider :in18="in18" :slider="new_slider"/><!-- /.section -->

  <info-block :in18="in18" :info_link="info_link" :info_banner="info_banner"/><!-- /.info-block -->

  <auto-slider :in18="in18" :slider="discount_slider"/><!-- /.section -->

  <auto-slider :in18="in18" :slider="recommended_slider"/><!-- /.section -->

  <div v-if="shop_code === 'lv_shop'">
    <div class="elfsight-app-5d93bf83-ac23-4be0-8cb4-7c089e07fbfc" data-elfsight-app-lazy></div>
    <div class="elfsight-app-caed39f4-a88a-4d5f-ab6b-74049dadf202" data-elfsight-app-lazy></div>
    <div class="elfsight-app-5b8511df-dd23-485d-a226-4ae8471646cc" data-elfsight-app-lazy></div>
    <div class="elfsight-app-43f42fb4-7be9-45df-ba3b-2272c3626ca7" data-elfsight-app-lazy></div>
  </div>

  <blog-articles :in18="in18" :blog_articles="blog_articles" :blog_link="blog_link"/><!-- /.section -->

  <manufacturers v-if="shop_code !== 'tt_fi_tel_shop'" :in18="in18" :manufacturers="manufacturers" :manufacturers_link="manufacturers_link"/><!-- /.section -->

</template>

<script>

import CategoryList from "../components/home/CategoryList.vue"
import Gallery from "../components/banner/Gallery.vue"
import Benefits from "../components/banner/Benefits.vue"
import Extras from "../components/banner/Extras.vue"
import BlogArticles from "../components/home/BlogArticles.vue"
import InfoBlock from "../components/home/InfoBlock.vue"
import HomeVideo from "../components/home/HomeVideo.vue"
import Manufacturers from "../components/home/Manufacturers.vue"

export default {
  name:       "Home",
  components: {
    CategoryList,
    Gallery,
    Benefits,
    Extras,
    BlogArticles,
    InfoBlock,
    HomeVideo,
    Manufacturers,
  },
  mounted() {
    if (!document.getElementById("elfsight-script")) {
      const script = document.createElement("script");
      script.id = "elfsight-script";
      script.src = "https://static.elfsight.com/platform/platform.js";
      script.async = true;
      document.body.appendChild(script);
    }
  },
  props:      [
    'in18',
    'shop_code',
    'root_categories',
    'gallery_banners',
    'benefit_banners',
    'extra_banners',
    'info_banner',
    'home_video_url',
    'blog_articles',
    'blog_link',
    'manufacturers',
    'manufacturers_link',
    'info_link',

    'featured_slider',
    'new_slider',
    'popular_slider',
    'discount_slider',
    'recommended_slider',
  ],
}
</script>
